import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Chevron,
  ScreenContent,
  SectionTitle,
  StyledTitleContainer,
  ViewMoreContainer,
  ViewMoreText,
  Button,
} from "./NewCustomerPage.styles";

import { ReactComponent as Loading } from "../../../../assets/icons/loader-white.svg";

import SignUpFormComponent from "../../../OnboardingPages/SignupPage/SignUpFormComponent";

import { isValidEmail, isValidPassword } from "../../../../utils/utils";
import openToast from "../../../../utils/toast";

import { selectedLocale } from "../../../../store/slices/common/slice";
import { selectedCreateCustomerLoading } from "../../../../store/slices/businessUser/slice";
import { createCustomer } from "../../../../store/slices/businessUser/asyncThunks";

const NewCustomerPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useSelector(selectedCreateCustomerLoading);
  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const [checkValidation, setCheckValidation] = useState(false);

  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [visibility, setVisibility] = useState(false);
  const [visibility2, setVisibility2] = useState(false);

  const toastId = useRef(null);

  const validateForm = () => {
    let formIsValid = true;

    if (!companyName) {
      openToast(toastId, "sign-up", "error", t("company-name-is-required"));
      formIsValid = false;
      return;
    }

    if (!fullName) {
      openToast(toastId, "sign-up", "error", t("full-name-is-required"));
      formIsValid = false;
      return;
    }

    if (!email) {
      openToast(toastId, "sign-up", "error", t("email-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidEmail(email)) {
      openToast(toastId, "sign-up", "error", t("invalid-email-format"));

      formIsValid = false;
      return;
    }

    if (!password) {
      openToast(toastId, "sign-up", "error", t("password-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidPassword(password)) {
      openToast(toastId, "sign-up", "info", t("password-contain"));
      formIsValid = false;
      return;
    }

    if (!confirmPassword) {
      openToast(toastId, "sign-up", "error", t("confirm-password-is-required"));
      formIsValid = false;
      return;
    } else if (confirmPassword !== password) {
      openToast(toastId, "sign-up", "error", t("password-dont-match"));
      formIsValid = false;
      return;
    }

    return formIsValid;
  };

  const onCreate = () => {
    setCheckValidation(true);
    if (validateForm()) {
      dispatch(createCustomer({ email, fullName, password, companyName }))
        .unwrap()
        .then((response) => {
          openToast(
            toastId,
            "success-sign-up",
            "success",
            t("account-created-successfully")
          );
          navigate(-1);
        })
        .catch((error) => {
          openToast(toastId, "sign-up", "error", t(error.message));
        });
    }
  };

  return (
    <>
      <StyledTitleContainer>
        <SectionTitle>{t("new-customer")}</SectionTitle>

        <ViewMoreContainer
          onClick={() => {
            navigate("/admin-portal/customers?page=1");
          }}
        >
          <Chevron $ar={!ar} />
          <ViewMoreText>{t("back")}</ViewMoreText>
        </ViewMoreContainer>
      </StyledTitleContainer>

      <ScreenContent>
        <SignUpFormComponent
          ar={ar}
          checkValidation={checkValidation}
          setFullName={setFullName}
          fullName={fullName}
          email={email}
          companyName={companyName}
          setCompanyName={setCompanyName}
          setEmail={setEmail}
          visibility={visibility}
          visibility2={visibility2}
          confirmPassword={confirmPassword}
          password={password}
          setPassword={setPassword}
          setConfirmPassword={setConfirmPassword}
          setVisibility={setVisibility}
          setVisibility2={setVisibility2}
          showFullName
          hideFirstAndLastName
          inputBackgroundColorWhite
        />

        {loading ? (
          <Button $disabled style={{ width: 186, alignSelf: "center" }}>
            <Loading height={25} />
          </Button>
        ) : (
          <Button
            onClick={onCreate}
            style={{ width: 186, alignSelf: "center" }}
          >
            {t("create-customer")}
          </Button>
        )}
      </ScreenContent>
    </>
  );
};

export default NewCustomerPage;
